import { IUser } from "modules/app/types";

export const getMethodsFromUserData = (userData: Partial<IUser>): string[] => {
  const methods: string[] = ["emailLink"];

  if (userData.google) {
    methods.push("google.com");
  } else if (userData.facebook) {
    methods.push("facebook.com");
  } else if (userData.linkedin) {
    methods.push("linkedin.com");
  } else if (userData.microsoft) {
    methods.push("microsoft.com");
  }

  return methods;
};
